// extracted by mini-css-extract-plugin
export var container = "_g2-0";
export var outlet = "_g2-1";
export var outletEnter = "_g2-2";
export var outletEnterActive = "_g2-3";
export var outletExit = "_g2-4";
export var outletExitActive = "_g2-5";